export const environment = {
  apiUrl: 'https://elpe-dev.arx.net',
  recapchaKey: "6LcDREIeAAAAAM9Yc1fUpIZ-hCmwVQ6AyPvrxx5l",
  environmentName: 'deva',
  domainCookieLang: '.elpe-dev.arx.net',
  production: false,
  googleMapsApiKey: 'AIzaSyBjaPDGFtkRtd56rAmEoWokUaI2oI0UIyI',
  enableBannerFeature: false,
  discoverTheService: 'https://www.eko.gr/product-category/eko-charge-and-go',
  downloadEkoApp: 'https://www.eko.gr/ekoappdownload'
};